import React, { useEffect, useState } from "react";
import DefaultLayout from "../components/DefaultLayout";
import axios from "axios";
import { Row, Col, message, Input } from "antd";
import TableList from "../components/TableList";
import config from "../config";
import QueList from "../components/queList";
import { io } from "socket.io-client";
import { SearchOutlined } from '@ant-design/icons';
const Homepage = () => {
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;
  const [tablesData, setTablesData] = useState([]);
  const [filteredTablesData, setFilteredTablesData] = useState([]);
  const [availableTable, setAvailableTable] = useState([]);
  // const { Search } = Input;

  useEffect(() => {
    console.log("window.env:", window.env);
    const getAllItems = async () => {
      try {
        const { data } = await axios.get(`${apiBaseUrl}/api/tables/get-table`);

        setTablesData(data.filter((table) => table.table_status === true));
        setAvailableTable(data.filter((table) => table.table_status === true));
        setFilteredTablesData(
          data.filter((table) => table.table_status === true)
        );
      } catch (error) {
        console.log(error);
      }
    };
    getAllItems();
  }, []);

  const [restaurantName, setRestaurantName] = useState(null);
  const [imageLogo, setImageLogo] = useState(null);
  const [restaurantAddress, setRestaurantAddress] = useState(null);
  const [sentToKitchen, setSentToKitchen] = useState(false);
  const [settings, setSettings] = useState({});

  // Orders state
  const [tableOrders, setTableOrders] = useState({}); // { [tableNumber]: [orders] }
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  // Fetch settings
  const getSetting = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(
        `${apiBaseUrl}/api/settings/get-settings`
      );
      if (data && data.image) {
        setImageLogo(data.image);
        setRestaurantName(data.name);
        setRestaurantAddress(data.address);
        setSentToKitchen(data.sentToKitchenToggle);
        setSettings(data);
      } else {
        setImageLogo(
          "https://bucketergroup.s3.ap-southeast-1.amazonaws.com/posfolder/logo.png"
        );
        setRestaurantName("Seiwaa");
        setRestaurantAddress("72 Dunlop Street, Singapore 209400");
        setSentToKitchen(false);
      }

      // if (localStorage.getItem("adminToken") === null) {
      //   const { data } = await axios.get(`${apiBaseUrl}/api/tables/getAdminToken`);
      //   console.log("Token", data.token);
      //   if (data.token) {
      //     localStorage.setItem("adminToken", data.token);
      //   } else {
      //     message.error("Something Went Wrong");
      //   }
      // }
    } catch (error) {
      message.error("Something Went Wrong");
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  // Fetch all tables
  useEffect(() => {
    const getAllItems = async () => {
      try {
        const { data } = await axios.get(`${apiBaseUrl}/api/tables/get-table`);
        setTablesData(data.filter(table => table.table_status === true));
        setAvailableTable(data.filter(table => table.table_status === true));
        setFilteredTablesData(data.filter(table => table.table_status === true));
      } catch (error) {
        console.log(error);
      }
    };
    getAllItems();
  }, []);

  // Fetch orders for all tables
  const fetchTableOrders = async () => {
    try {
      // Get all orders for all tables
      const { data } = await axios.get(`${apiBaseUrl}/api/orders/get-all-orders`);
      // Group orders by table_number
      const grouped = {};
      data.forEach(order => {
        if (!grouped[order.order_tablenumber]) grouped[order.order_tablenumber] = [];
        grouped[order.order_tablenumber].push(order);
      });
      setTableOrders(grouped);
    } catch (error) {
      console.error("Error fetching all orders:", error);
    }
  };

  // Socket.io logic
  useEffect(() => {
    const socket = io(config.REACT_APP_API_BASE_URL, { transports: ["websocket"] });
    socket.on("newOrder", () => {
      fetchTableOrders();
    });
    return () => socket.disconnect();
  }, []);

  // Fetch settings on mount
  useEffect(() => {
    getSetting();
  }, []);

  // Initial load of orders
  useEffect(() => {
    fetchTableOrders();
  }, []);

  // Filter tables by search
  useEffect(() => {
    if (searchText) {
      setFilteredTablesData(
        tablesData.filter((table) => table.table_number.includes(searchText))
      );
    } else {
      setFilteredTablesData(tablesData);
    }
  }, [searchText, tablesData]);

  // Handle search input change
  const handleSearch = (searchValue) => {
    const lowerSearchValue = searchValue.toLowerCase();

    if (searchValue) {
      setFilteredTablesData(
        tablesData.filter(table =>
          table.table_number.toLowerCase().includes(lowerSearchValue)
        )
      );
      console.log("tablesData", tablesData, searchValue);
    } else {
      setFilteredTablesData(tablesData);
    }
  };


  return (
    <DefaultLayout searchPlaceholder="Table Name" onSearch={handleSearch}>
      {/* <Row>
        {
          tablesData.map((table, index) => (
            <Col key={index} xs={24} lg={6} md={12} sm={6}>

              <TableList table={table}></TableList>
            </Col>

          ))
        }
      </Row> */}

      {/* <Row style={{ marginBottom: "16px" }}>
        <Col key={4}>
          <QueList tables={availableTable} restaurantName={restaurantName} imageLogo={imageLogo} restaurantAddress={restaurantAddress}/>
        </Col>
      </Row> */}
      {/* <Search
        placeholder="Search"
        onChange={(e) => setSearchText(e.target.value)}
        style={{ width: 200, marginLeft: 11 }}
        allowClear
      /> */}
      <div className={`table-list-page table-count-${filteredTablesData.length}`}>
        {filteredTablesData.map((table, index) => (
          <div key={index} style={{ margin: 0 }}>
            <TableList
              tablesData={availableTable}
              table={table}
              restaurantName={restaurantName}
              imageLogo={imageLogo}
              restaurantAddress={restaurantAddress}
              sentToKitchen={sentToKitchen}
              tableOrders={tableOrders[table.table_number] || []}
              settings={settings}
              paymentMethods={Array.isArray(settings.paymentMethods) ? settings.paymentMethods.filter(m => m.enabled) : []}
            />
          </div>
        ))}
      </div>
    </DefaultLayout>
  );
};

export default Homepage;
